import Layout from "../../../components/layout/layout.js";
import KeyPlayerContactsDirectory from "../../../components/componentsPage/keyPlayerContactsDirectory/index.js";

function KeyPlayerContactsDirectoryPage({ component, ...rest }) {
  return <Layout Component={KeyPlayerContactsDirectory} controlsDisabled={true} {...rest} />;
}

export default KeyPlayerContactsDirectoryPage;
